(function() {
    'use strict';

    angular
        .module('eDocumentsApp')
        .factory('PasswordResetFinish', PasswordResetFinish);

    PasswordResetFinish.$inject = ['$resource'];

    function PasswordResetFinish($resource) {
        return $resource('api/account/reset-password/finish', {}, {});
    }
})();
